import { render, staticRenderFns } from "./BrandView.vue?vue&type=template&id=151be807&scoped=true&"
import script from "./BrandView.vue?vue&type=script&lang=ts&"
export * from "./BrandView.vue?vue&type=script&lang=ts&"
import style0 from "./BrandView.vue?vue&type=style&index=0&id=151be807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151be807",
  null
  
)

export default component.exports